"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7135],{

/***/ "./src/components/Activity/ActivityCard/index.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Activity_ActivityCard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("./node_modules/react/jsx-runtime.js");
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("./node_modules/react/index.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/index.esm.js + 5 modules
var index_esm = __webpack_require__("./node_modules/@chakra-ui/system/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__("./node_modules/next/link.js");
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__("./node_modules/next/router.js");
;// CONCATENATED MODULE: ./src/components/Activity/ActivityCard/ActivityCardTop.tsx




const getCategoryAbbr = (id)=>{
    switch(id){
        case "defi":
            return "Defi";
        case "people":
            return "PIC";
        case "dapps":
            return "Dapps";
        case "cryptocurrencies":
            return "Crypto";
        case "daos":
            return "DAOs";
        case "exchanges":
            return "Exch";
        case "nfts":
            return "Nfts";
        case "organizations":
            return "Org";
    }
};
const ActivityCardTop = (props)=>{
    const { title , activity , category , link  } = props;
    const router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
        justifyContent: "space-between",
        wrap: "wrap",
        alignItems: "center",
        mb: {
            base: 0,
            md: 2
        },
        width: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* HStack */.Ug, {
                flex: "1",
                sx: {
                    "@media screen and (max-width: 450px)": {
                        maxWidth: "200px"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        cursor: "pointer",
                        letterSpacing: "wide",
                        fontSize: {
                            base: 16,
                            md: "18px"
                        },
                        onClick: ()=>router.push(link),
                        tabIndex: 0,
                        role: "link",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                        fontSize: "xs",
                        color: "brandLinkColor",
                        fontWeight: "medium",
                        children: activity
                    })
                ]
            }),
            category && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Link */.rU, {
                as: (link_default()),
                href: "/categories/".concat(category === null || category === void 0 ? void 0 : category.id),
                color: "brandLinkColor",
                fontWeight: "bold",
                cursor: "pointer",
                fontSize: {
                    base: "14px",
                    lg: "16px"
                },
                display: {
                    base: "none",
                    md: "unset"
                },
                children: (category === null || category === void 0 ? void 0 : category.title) ? category === null || category === void 0 ? void 0 : category.title : category === null || category === void 0 ? void 0 : category.id
            }),
            category && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Link */.rU, {
                as: (link_default()),
                href: "/categories/".concat(category === null || category === void 0 ? void 0 : category.id),
                color: "brandLinkColor",
                fontWeight: "bold",
                cursor: "pointer",
                fontSize: {
                    base: "14px",
                    lg: "16px"
                },
                display: {
                    base: "block",
                    md: "none"
                },
                children: (category === null || category === void 0 ? void 0 : category.title) ? getCategoryAbbr(category === null || category === void 0 ? void 0 : category.id) : category === null || category === void 0 ? void 0 : category.id
            })
        ]
    });
};
/* harmony default export */ var ActivityCard_ActivityCardTop = (ActivityCardTop);

// EXTERNAL MODULE: ./node_modules/@chakra-ui/tag/dist/index.esm.js
var tag_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/tag/dist/index.esm.js");
// EXTERNAL MODULE: ./src/components/Elements/LinkElements/LinkWrapper.tsx
var LinkWrapper = __webpack_require__("./src/components/Elements/LinkElements/LinkWrapper.tsx");
;// CONCATENATED MODULE: ./src/components/Activity/ActivityCard/ActivityCardTags.tsx



const ActivityCardTags = (param)=>{
    let { tags  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Wrap */.Eq, {
        spacing: 2,
        children: tags === null || tags === void 0 ? void 0 : tags.map((tag, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* LinkWrapper */.g, {
                href: "/tags/".concat(tag.id),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tag_dist_index_esm/* Tag */.Vp, {
                    as: "a",
                    size: "sm",
                    whiteSpace: "nowrap",
                    minWidth: "0",
                    sx: {
                        p: {
                            base: {
                                padding: 0
                            }
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                        px: 4,
                        children: tag.id
                    })
                }, index)
            }, index))
    });
};
/* harmony default export */ var ActivityCard_ActivityCardTags = (ActivityCardTags);

;// CONCATENATED MODULE: ./src/components/Activity/ActivityCard/ActivityCardBody.tsx




const ActivityCardBody = (props)=>{
    const { isNotifSubCard , tags , summary  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                mt: "1",
                noOfLines: {
                    base: 3,
                    md: 2
                },
                textOverflow: "ellipsis",
                overflow: "hidden",
                width: "100%",
                fontSize: {
                    base: "14px",
                    md: isNotifSubCard ? "14px" : "16px"
                },
                children: summary
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* chakra.div */.m$.div, {
                display: {
                    base: "block",
                    md: "none"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityCard_ActivityCardTags, {
                    tags: tags
                })
            })
        ]
    });
};
/* harmony default export */ var ActivityCard_ActivityCardBody = (ActivityCardBody);

// EXTERNAL MODULE: ./src/utils/DataTransform/getFormattedDate.ts
var getFormattedDate = __webpack_require__("./src/utils/DataTransform/getFormattedDate.ts");
// EXTERNAL MODULE: ./src/utils/DataTransform/getUsername.ts
var getUsername = __webpack_require__("./src/utils/DataTransform/getUsername.ts");
// EXTERNAL MODULE: ./src/components/Elements/Avatar/DisplayAvatar.tsx
var DisplayAvatar = __webpack_require__("./src/components/Elements/Avatar/DisplayAvatar.tsx");
;// CONCATENATED MODULE: ./src/components/Activity/ActivityCard/ActivityCardBottom.tsx






const ActivityCardBottom = (props)=>{
    var ref, ref1;
    const { editor , isNotifSubCard , lastModTimeStamp , activity , tags  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* HStack */.Ug, {
        w: "full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* HStack */.Ug, {
                flex: "1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayAvatar/* default */.Z, {
                        address: editor.id,
                        avatarIPFS: (ref = editor.profile) === null || ref === void 0 ? void 0 : ref.avatar,
                        size: isNotifSubCard ? 15 : 20,
                        alt: (ref1 = editor.profile) === null || ref1 === void 0 ? void 0 : ref1.username
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                        fontSize: {
                            base: isNotifSubCard ? "12px" : "12px",
                            md: isNotifSubCard ? "12px" : "14px"
                        },
                        color: "linkColor",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Link */.rU, {
                            href: "/account/".concat(editor.id),
                            color: "brandLinkColor",
                            fontWeight: "bold",
                            children: (0,getUsername/* getUsername */.M)(editor)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* chakra.div */.m$.div, {
                        display: {
                            base: "none",
                            md: "block"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityCard_ActivityCardTags, {
                            tags: tags
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                mt: "3px",
                fontSize: {
                    base: isNotifSubCard ? "12px" : "12px",
                    md: isNotifSubCard ? "12px" : "14px"
                },
                opacity: 0.6,
                whiteSpace: "nowrap",
                children: "".concat(activity === "Edited" ? activity : "Created", " ").concat((0,getFormattedDate/* getReadableDate */._)(lastModTimeStamp !== null && lastModTimeStamp !== void 0 ? lastModTimeStamp : ""), " ago")
            })
        ]
    });
};
/* harmony default export */ var ActivityCard_ActivityCardBottom = (ActivityCardBottom);

// EXTERNAL MODULE: ./src/data/Constants.ts
var Constants = __webpack_require__("./src/data/Constants.ts");
// EXTERNAL MODULE: ./src/utils/WikiUtils/getWikiImageUrl.ts
var getWikiImageUrl = __webpack_require__("./src/utils/WikiUtils/getWikiImageUrl.ts");
// EXTERNAL MODULE: ./src/components/Elements/Image/Image.tsx
var Image = __webpack_require__("./src/components/Elements/Image/Image.tsx");
;// CONCATENATED MODULE: ./src/components/Activity/ActivityCard/ActivityCardImage.tsx





const ActivityCardImage = (props)=>{
    const { title , link , isNotifSubCard , wikiImgObj  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Link */.rU, {
        href: link,
        mr: 4,
        display: {
            base: "none",
            md: "block"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* AspectRatio */.oM, {
            ratio: Constants/* WIKI_IMAGE_ASPECT_RATIO */.ag,
            w: {
                base: isNotifSubCard ? "80px" : "100px",
                md: "140px",
                lg: "156px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                boxSize: "100%",
                cursor: "pointer",
                flexShrink: 0,
                src: (0,getWikiImageUrl/* getWikiImageUrl */.A)(wikiImgObj),
                borderRadius: "lg",
                overflow: "hidden",
                alt: title,
                imgBoxSize: Constants/* IMAGE_BOX_SIZE */.xh
            })
        })
    });
};
/* harmony default export */ var ActivityCard_ActivityCardImage = (ActivityCardImage);

;// CONCATENATED MODULE: ./src/components/Activity/ActivityCard/index.tsx







const ActivityCard = (props)=>{
    const { isNotifSubCard =false , title , summary , editor , categories , tags , lastModTimeStamp , activityId , wikiImgObj , wikiId , type , ipfs  } = props;
    const link = ipfs !== undefined ? "/revision/".concat(activityId) : "/wiki/".concat(wikiId);
    const activity = type === "CREATED" ? "New" : "Edited";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* chakra.div */.m$.div, {
        bg: "cardBg",
        py: 3,
        px: 2,
        borderRadius: 8,
        borderColor: "borderColor",
        borderWidth: "0.5px",
        borderStyle: "solid",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityCard_ActivityCardImage, {
                    title: title,
                    link: link,
                    isNotifSubCard: isNotifSubCard,
                    wikiImgObj: wikiImgObj
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* VStack */.gC, {
                    spacing: 2,
                    alignItems: "flex-start",
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityCard_ActivityCardTop, {
                            title: title,
                            link: link,
                            activity: activity,
                            category: categories === null || categories === void 0 ? void 0 : categories[0]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityCard_ActivityCardBody, {
                            link: link,
                            summary: summary,
                            isNotifSubCard: isNotifSubCard,
                            tags: tags
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityCard_ActivityCardBottom, {
                            activity: activity,
                            editor: editor,
                            lastModTimeStamp: lastModTimeStamp,
                            isNotifSubCard: isNotifSubCard,
                            tags: tags
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Activity_ActivityCard = (ActivityCard);


/***/ }),

/***/ "./src/components/Notification/NotificationCard.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cp": function() { return /* binding */ RemoveWikiSubscriptionHandler; },
/* harmony export */   "au": function() { return /* binding */ SubscribeWikiHandler; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("./node_modules/@chakra-ui/toast/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("./node_modules/@chakra-ui/button/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("./node_modules/@chakra-ui/icon/dist/index.esm.js");
/* harmony import */ var _components_Activity_ActivityCard__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/components/Activity/ActivityCard/index.tsx");
/* harmony import */ var _services_profile_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/services/profile/utils.ts");
/* harmony import */ var _services_notification__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/services/notification/index.ts");
/* harmony import */ var _store_store__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/store/store.ts");
/* harmony import */ var _services_notification_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/services/notification/utils.ts");
/* harmony import */ var react_icons_ri__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("./node_modules/react-icons/ri/index.esm.js");
/* harmony import */ var _utils_WalletUtils_getUserAddressFromCache__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/utils/WalletUtils/getUserAddressFromCache.ts");










const SubscribeWikiHandler = async (email, wiki, userAddress, toast)=>{
    if (!email) {
        toast({
            title: "Subscription Failed",
            description: "Please add email to your profile settings.",
            status: "error",
            duration: 5000,
            isClosable: true
        });
        return;
    }
    if (wiki) {
        await _store_store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch(_services_notification__WEBPACK_IMPORTED_MODULE_4__/* .addSubscription.initiate */ .VF.initiate({
            userId: userAddress,
            subscriptionType: "wiki",
            auxiliaryId: wiki.id,
            wiki
        }));
    }
};
const RemoveWikiSubscriptionHandler = async (email, wikiId, userAddress, toast)=>{
    if (!email) {
        toast({
            title: "Remove Subscription Failed",
            description: "Please add email to your profile settings.",
            status: "error",
            duration: 5000,
            isClosable: true
        });
        return;
    }
    if (wikiId) {
        await _store_store__WEBPACK_IMPORTED_MODULE_5__/* .store.dispatch */ .h.dispatch(_services_notification__WEBPACK_IMPORTED_MODULE_4__/* .removeSubscription.initiate */ .AL.initiate({
            userId: userAddress,
            subscriptionType: "wiki",
            auxiliaryId: wikiId
        }));
    }
};
const NotificationCard = (param)=>{
    let { title , brief , editor , categories , tags , lastModTimeStamp , WikiImgObj , wikiId , type , defaultSubscribed  } = param;
    const userAddress = (0,_utils_WalletUtils_getUserAddressFromCache__WEBPACK_IMPORTED_MODULE_7__/* .getUserAddressFromCache */ .X)();
    const { setAccount , profileData  } = (0,_services_profile_utils__WEBPACK_IMPORTED_MODULE_3__/* .useUserProfileData */ .Cf)(_services_profile_utils__WEBPACK_IMPORTED_MODULE_3__/* .UserProfileFetchOptions.WITH_ALL_SETTINGS */ .Ky.WITH_ALL_SETTINGS);
    const isWikiSubscribed = (0,_services_notification_utils__WEBPACK_IMPORTED_MODULE_6__/* .useIsWikiSubscribed */ .F)(wikiId, userAddress);
    const toast = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .useToast */ .pm)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (userAddress) {
            setAccount(userAddress);
        }
    }, [
        userAddress,
        setAccount
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .HStack */ .Ug, {
        gap: {
            base: 2,
            lg: 10
        },
        w: "full",
        justifyContent: "space-between",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Activity_ActivityCard__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                isNotifSubCard: true,
                title: title,
                summary: brief,
                editor: editor,
                lastModTimeStamp: lastModTimeStamp,
                type: type,
                wikiId: wikiId,
                categories: categories,
                tags: tags,
                wikiImgObj: WikiImgObj
            }),
            defaultSubscribed || isWikiSubscribed ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Button */ .zx, {
                w: {
                    base: 8,
                    md: "initial"
                },
                h: {
                    base: 10
                },
                display: {
                    base: "flex",
                    md: "inline-flex"
                },
                alignItems: {
                    base: "center"
                },
                justifyContent: {
                    base: "center"
                },
                variant: "outline",
                px: {
                    base: 0,
                    md: 7
                },
                fontSize: {
                    base: "xs",
                    md: "sm"
                },
                onClick: ()=>{
                    return RemoveWikiSubscriptionHandler(profileData === null || profileData === void 0 ? void 0 : profileData.email, wikiId, userAddress, toast);
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .xv, {
                        display: {
                            base: "none",
                            md: "block"
                        },
                        children: "Remove"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Icon */ .JO, {
                        as: react_icons_ri__WEBPACK_IMPORTED_MODULE_12__/* .RiSubtractLine */ .tRM,
                        w: 6,
                        h: 6,
                        display: {
                            base: "block",
                            md: "none"
                        },
                        fill: "NotificationRemoveIcon"
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Button */ .zx, {
                w: {
                    base: 8,
                    md: "initial"
                },
                h: {
                    base: 10
                },
                display: {
                    base: "flex",
                    md: "inline-flex"
                },
                alignItems: {
                    base: "center"
                },
                justifyContent: {
                    base: "center"
                },
                px: {
                    base: 0,
                    md: 10
                },
                fontSize: {
                    base: "xs",
                    md: "md"
                },
                onClick: ()=>{
                    return SubscribeWikiHandler(profileData === null || profileData === void 0 ? void 0 : profileData.email, {
                        title,
                        summary: brief,
                        user: editor,
                        categories,
                        tags,
                        updated: lastModTimeStamp,
                        images: WikiImgObj,
                        id: wikiId
                    }, userAddress, toast);
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .xv, {
                        display: {
                            base: "none",
                            md: "block"
                        },
                        children: "Add"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Icon */ .JO, {
                        as: react_icons_ri__WEBPACK_IMPORTED_MODULE_12__/* .RiAddLine */ .p22,
                        w: 6,
                        h: 6,
                        display: {
                            base: "block",
                            md: "none"
                        },
                        fill: "NotificationAddIcon"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (NotificationCard);


/***/ }),

/***/ "./src/services/notification/utils.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useIsWikiSubscribed; }
/* harmony export */ });
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/services/notification/index.ts");

const useIsWikiSubscribed = (wikiId, userID)=>{
    const { data  } = (0,___WEBPACK_IMPORTED_MODULE_0__/* .useGetAllWikiSubscriptionQuery */ .ZG)(userID);
    return data === null || data === void 0 ? void 0 : data.some((sub)=>sub.auxiliaryId === wikiId);
};


/***/ }),

/***/ "./src/services/wikis/utils.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ incrementWikiViewCount; },
/* harmony export */   "T": function() { return /* binding */ useWikiSubRecommendations; }
/* harmony export */ });
/* harmony import */ var _store_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/store/store.ts");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/services/wikis/index.ts");
/* harmony import */ var _notification__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/services/notification/index.ts");




const incrementWikiViewCount = async (slug)=>{
    if (!slug) return;
    const visitedWikis = JSON.parse(localStorage.getItem("VISITED_WIKIS") || "[]");
    const visitedWiki = visitedWikis.find((w)=>w.slug === slug);
    if (!visitedWiki || visitedWiki && Date.now() - visitedWiki.timestamp > 1000 * 60 * 60) {
        _store_store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch(___WEBPACK_IMPORTED_MODULE_2__/* .postWikiViewCount.initiate */ .Jv.initiate(slug));
        if (visitedWikis.length > 20) {
            visitedWikis.shift();
        }
        visitedWikis.push({
            slug,
            timestamp: Date.now()
        });
        localStorage.setItem("VISITED_WIKIS", JSON.stringify(visitedWikis));
    }
};
function shuffleArray(a) {
    const array = [
        ...a
    ];
    for(let i = array.length - 1; i > 0; i -= 1){
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [
            array[j],
            array[i]
        ];
    }
    return array;
}
const useWikiSubRecommendations = (userId)=>{
    const [recommendations, setRecommendations] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const { data: wikiSubs  } = (0,_notification__WEBPACK_IMPORTED_MODULE_3__/* .useGetAllWikiSubscriptionQuery */ .ZG)(userId || "");
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const getRecommendations = async ()=>{
            if (!userId) return;
            setLoading(true);
            // GET ALL USER MODIFIED WIKIS
            let userModifiedWikis = [];
            let newRecommendations = [];
            await Promise.all([
                _store_store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch(___WEBPACK_IMPORTED_MODULE_2__/* .getUserCreatedWikis.initiate */ .OS.initiate({
                    id: userId,
                    limit: 10
                })),
                _store_store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch(___WEBPACK_IMPORTED_MODULE_2__/* .getUserEditedWikis.initiate */ .Or.initiate({
                    id: userId,
                    limit: 10
                }))
            ]).then((res)=>{
                const [createdWikis, editedWikis] = res;
                userModifiedWikis = shuffleArray([
                    ...createdWikis.data || [],
                    ...editedWikis.data || []
                ]);
            });
            // GENERATE RECOMMENDATIONS
            if (!recommendations.length) {
                newRecommendations = userModifiedWikis.filter((w, i, self)=>i === self.findIndex((t)=>t.content[0].id === w.content[0].id)).filter((w)=>{
                    return !(wikiSubs === null || wikiSubs === void 0 ? void 0 : wikiSubs.find((s)=>s.auxiliaryId === w.content[0].id));
                }).slice(0, 3);
            } else {
                const getNewRecommendation = ()=>{
                    let randomWiki = null;
                    userModifiedWikis.every((w)=>{
                        const isWikiAlreadyRecommended = recommendations.find((r)=>r.content[0].id === w.content[0].id);
                        const isWikiAlreadySubscribed = wikiSubs === null || wikiSubs === void 0 ? void 0 : wikiSubs.find((s)=>s.auxiliaryId === w.content[0].id);
                        if (!isWikiAlreadyRecommended && !isWikiAlreadySubscribed) {
                            randomWiki = w;
                            return false;
                        }
                        return true;
                    });
                    return randomWiki;
                };
                // GET NEW RECOMMENDATION
                const newWiki = getNewRecommendation();
                // REPLACE OLD SUBSCRIBED RECOMMENDATION
                newRecommendations = recommendations.map((r)=>{
                    const isWikiAlreadySubscribed = wikiSubs === null || wikiSubs === void 0 ? void 0 : wikiSubs.find((s)=>s.auxiliaryId === r.content[0].id);
                    if (isWikiAlreadySubscribed) {
                        return newWiki || null;
                    }
                    return r;
                }).filter(Boolean);
                while(userModifiedWikis.length - ((wikiSubs === null || wikiSubs === void 0 ? void 0 : wikiSubs.length) || 0) > newRecommendations.length && newRecommendations.length < 3){
                    const otherNewWiki = getNewRecommendation();
                    if (otherNewWiki) {
                        newRecommendations.push(otherNewWiki);
                    }
                }
            }
            // SET RECOMMENDATIONS STATE
            setRecommendations(newRecommendations);
            setLoading(false);
        };
        getRecommendations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        userId,
        wikiSubs
    ]);
    return {
        recommendations,
        loading
    };
};


/***/ }),

/***/ "./src/utils/WikiUtils/getWikiSummary.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ WikiSummarySize; },
/* harmony export */   "L": function() { return /* binding */ getWikiSummary; }
/* harmony export */ });
/* harmony import */ var _textUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/utils/textUtils.ts");

var WikiSummarySize;
(function(WikiSummarySize) {
    WikiSummarySize[WikiSummarySize["Small"] = 65] = "Small";
    WikiSummarySize[WikiSummarySize["Medium"] = 70] = "Medium";
    WikiSummarySize[WikiSummarySize["BIG"] = 110] = "BIG";
    WikiSummarySize[WikiSummarySize["Huge"] = 160] = "Huge";
})(WikiSummarySize || (WikiSummarySize = {}));
const getWikiSummary = function(wiki) {
    let size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : WikiSummarySize.Huge;
    if (wiki.summary) return (0,_textUtils__WEBPACK_IMPORTED_MODULE_0__/* .shortenText */ .El)(wiki.summary, size);
    return "";
};


/***/ })

}]);